import {useSelector, useDispatch } from "react-redux";
import {setLogout} from "../features/authSlice";
import style from "./Homeheader.module.css"
import { useNavigate } from "react-router";

function Homeheader() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token, user:{role}  } = useSelector((state) => state.auth);
  return (
    <header className={style.homeHeader}>
        <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="logo"  />
        <h1>Smart City System</h1>
        {token && <button className={style.logoutBtn} onClick={() => {dispatch(setLogout()); navigate('/login')}}>{role ? `Logout as ${role}` : "Logout"}</button>}
      </header>
  );
}

export default Homeheader;